import { Typography } from '@mui/material';
import {
  Theme,
  useTheme,
} from '@mui/material/styles';
import { createStyles, makeStyles } from '@mui/styles';
import { BaseButton } from 'components/BaseButton';
import React from 'react';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles((theme: Theme) => createStyles({
  root: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(0.5),
    marginBottom: theme.spacing(1),
  },
  summary: {
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: theme.spacing(1),
  },
  limit: {
    color: theme.palette.text.secondary,
  },
}));

type PageSelectionBarProps = {
  selectedCount: number;
  maxSelected: number;
  disabled: boolean;
  onClear: () => void;
};

/** "N of max pages selected", the clear action, and the limit notice once the cap is reached. */
export const PageSelectionBar = ({
  selectedCount, maxSelected, disabled, onClear,
}: PageSelectionBarProps) => {
  const classes = useStyles();
  const theme = useTheme();
  const { t } = useTranslation();
  const canClear = !disabled && selectedCount > 0;

  return (
    <div className={classes.root}>
      <div className={classes.summary}>
        <Typography variant="body2" role="status">
          {t('imports:pages.selectedCount', { selected: selectedCount, max: maxSelected })}
        </Typography>
        <BaseButton
          text={t('imports:pages.clearSelection')}
          buttonVariant="text"
          buttonColor="inherit"
          textColor={canClear ? theme.palette.primary.main : theme.palette.text.disabled}
          height={theme.spacing(5.5)}
          disabled={!canClear}
          onClick={onClear}
        />
      </div>
      {selectedCount >= maxSelected && (
        <Typography variant="caption" className={classes.limit}>
          {t('imports:pages.limitReached', { max: maxSelected })}
        </Typography>
      )}
    </div>
  );
};
